import {createStore, combineReducers} from 'redux';
import educationReducer from './../reducers/education';
import experienceReducer from './../reducers/experience';
import introductionReducer from './../reducers/introduction';
import certificationReducer from './../reducers/certification';
import skillsReducer from './../reducers/skills';
import udemyReducer from './../reducers/udemy';
import youtubeReducer from './../reducers/youtube';

//Store creattion
export default () =>{
    const store = createStore(
        combineReducers({
            education: educationReducer,
            experience: experienceReducer,
            introduction: introductionReducer,
            certification: certificationReducer,
            skills: skillsReducer,
            udemy: udemyReducer,
            youtube: youtubeReducer
        }), 
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );

    return store; 
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js